export default __webpack_public_path__ + "static/media/tags24.e1316cee.svg";